module.exports = __webpack_public_path__ + "static/media/docker.f98f3826.svg";